/** @format */
export const ContainerId = {
	CART_FBT : 'cart_FBT',
	GG_CART_FBT : 'ECOMM_WEB_GG_CART_FBT',
	PL_CART_FBT : 'ECOMM_WEB_PL_CART_FBT',
	ORDERCONFIRM_FBT : 'orderconfirm_FBT',
	GG_ORDERCONFIRM_FBT : 'ECOMM_WEB_GG_orderConfirm_FBT',
	PL_ORDERCONFIRM_FBT : 'ECOMM_WEB_PL_orderConfirm_FBT',
	ORDERHISTORY_FBT : 'OrderHistory_FBT',
	PDP_ATC : 'PDP_ATC',
	PDP_YMAL : 'PDP_YMAL',
	PDP_PLA : 'PDP_PLA',
	YMAL : 'YMAL',
	PLA : 'PLA',
	ID : 'containerId',
	FAVORITES_FBT: 'Favorites_FBT'
};

